// The legal block of the sign-up forms (shipper, warehouse, carrier): contract
// language, the English choice, acceptance of the Terms and Privacy Policy, and
// optional marketing consent. French always comes first.

export const LEGAL_PATHS = {
  terms: { fr: "/conditions", en: "/terms" },
  privacy: { fr: "/confidentialite", en: "/privacy" },
};

export const INITIAL_LEGAL_AGREEMENT = {
  contract_language: "fr",
  english_choice_confirmed: false,
  accept_terms: false,
  marketing_consent: false,
};

export const LEGAL_ERRORS = {
  accept_terms:
    "Vous devez accepter les Conditions d'utilisation et la Politique de confidentialité. / You must accept the Terms of Service and the Privacy Policy.",
  english_choice_confirmed:
    "Confirmez que vous choisissez d'être lié(e) par la version anglaise. / Confirm that you choose to be bound by the English version.",
};

export const validateLegalAgreement = (value) => {
  const errors = {};
  if (!value.accept_terms) {
    errors.accept_terms = LEGAL_ERRORS.accept_terms;
  }
  if (value.contract_language === "en" && !value.english_choice_confirmed) {
    errors.english_choice_confirmed = LEGAL_ERRORS.english_choice_confirmed;
  }
  return errors;
};

// Drops the legal errors the new value no longer has.
export const clearLegalErrors = (errors, value) => {
  const still = validateLegalAgreement(value);
  const next = { ...errors };
  Object.keys(LEGAL_ERRORS).forEach((key) => {
    if (next[key] && !still[key]) {
      next[key] = "";
    }
  });
  return next;
};

export const legalAgreementPayload = (value) => ({
  contract_language: value.contract_language,
  accept_terms: Boolean(value.accept_terms),
  english_choice_confirmed:
    value.contract_language === "en" && Boolean(value.english_choice_confirmed),
  marketing_consent: Boolean(value.marketing_consent),
});
